import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import EmptyState from './EmptyState';
import { cn } from '@/lib/utils';

/**
 * Standard chrome for every chart on the platform: title, optional
 * description/badge slot, loading skeleton, and a real empty state when
 * there's genuinely no data to plot (never a fabricated placeholder chart).
 */
const ChartContainer = ({
  title,
  description,
  action,
  loading = false,
  isEmpty = false,
  emptyProps,
  height = 280,
  className,
  children,
}) => {
  return (
    <Card className={cn('animate-fade-in-up flex h-full flex-col', className)}>
      <CardHeader className="flex flex-row items-start justify-between gap-4 pb-2">
        <div>
          <CardTitle className="text-sm font-semibold">{title}</CardTitle>
          {description && <CardDescription className="mt-1 text-xs">{description}</CardDescription>}
        </div>
        {action}
      </CardHeader>
      <CardContent className="flex flex-1 flex-col">
        {loading ? (
          <Skeleton style={{ minHeight: height }} className="w-full flex-1 rounded-lg" />
        ) : isEmpty ? (
          <div style={{ minHeight: height }} className="flex flex-1 items-center justify-center">
            <EmptyState compact {...emptyProps} />
          </div>
        ) : (
          <div style={{ minHeight: height }} className="min-h-0 flex-1">{children}</div>
        )}
      </CardContent>
    </Card>
  );
};

export default ChartContainer;
